import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Image from '../../../Assets/assetHelper';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import KenColors from '../../../Helpers/Themes/kenColors';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  hideSideBar: boolean;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick, hideSideBar }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const {
    state: { user },
  } = useContext(AuthContext);
  const [openPeople, setOpenPeople] = useState(false);

  const handlePeopleClick = () => {
    setOpenPeople(!openPeople);
  };

  const roles = user?.contactRoles || [];
  const isInvestor = ['Strategic Investor', 'Passive Investor'].some((role) => roles?.includes(role));
  const isJuryMember = roles?.includes('Jury Member');
  const hasAllRoles = isInvestor && isJuryMember;

  const showMenuItem = (roleNeeded: boolean) => roleNeeded || hasAllRoles;

  const sideNavContents = [
    showMenuItem(true) && {
      icon: (isActive: boolean) => <img src={Image.Icons.websplitIcon} alt="websplitIcon" className={isActive ? classes.listItemImgActive : classes.listItemImg} />,
      label: 'Jury',
      link: routes.juryPortal,
      name: 'jury',
    },
  ].filter(Boolean);

  const isActive = (link: string) => pathname?.startsWith(link);
  const isAnyNestedItemActive = (nestedItems: any[]) => {
    return nestedItems.some((nestedItem) => isActive(nestedItem.link));
  };

  return (
    <>
      {sideNavContents.map((items, index) => {
        if (items.nested) {
          const anyNestedItemActive = isAnyNestedItemActive(items.nestedItems);
          return (
            <div key={index}>
              <ListItemButton
                onClick={handlePeopleClick}
                sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px' }}
                className={`${classes.listItemButton} ${anyNestedItemActive && classes.nestedlistItemButtonActive}`}
              >
                <ListItemIcon sx={{ minWidth: '40px' }}>{items?.icon(items?.nestedItems.some((nestedItem: any) => isActive(nestedItem.link)))}</ListItemIcon>
                {!hideSideBar && (
                  <>
                    <ListItemText
                      className={`${classes.listItemText} ${items?.nestedItems.some((nestedItem: any) => isActive(nestedItem?.link)) && classes.listItemTextActive}`}
                      sx={{
                        display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                      }}
                    >
                      {items.label}
                    </ListItemText>
                    {openPeople ? <ExpandLess sx={{ color: KenColors.kenWhite }} /> : <ExpandMore sx={{ color: KenColors.kenWhite }} />}
                  </>
                )}
              </ListItemButton>
              <Collapse in={openPeople} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {items?.nestedItems.map((nestedItem: any, nestedIndex: any) => (
                    <ListItemButton
                      key={nestedIndex}
                      onClick={() => handleListClick(nestedItem?.link, nestedIndex)}
                      className={`${classes.listItemButton} ${isActive(nestedItem?.link) && classes.listItemButtonActive}`}
                    >
                      <Box sx={{ ml: hideSideBar ? 0 : 1.5, display: 'flex', alignItems: 'center' }}>
                        <ListItemIcon sx={{ minWidth: '40px' }}>{nestedItem?.icon(isActive(nestedItem?.link))}</ListItemIcon>
                        {!hideSideBar && (
                          <ListItemText
                            primary={nestedItem?.label}
                            className={`${classes.listItemText} ${isActive(nestedItem?.link) && classes.listItemTextActive}`}
                            sx={{
                              display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                            }}
                          />
                        )}
                      </Box>
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </div>
          );
        } else {
          return (
            <ListItemButton
              key={index}
              onClick={() => {
                handleListClick(items?.link, index);
              }}
              sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px' }}
              className={`${classes.listItemButton} ${isActive(items?.link) && classes.listItemButtonActive}`}
            >
              <ListItemIcon sx={{ minWidth: '40px' }}>{items?.icon(isActive(items?.link))}</ListItemIcon>
              {!hideSideBar && (
                <ListItemText
                  className={`${classes.listItemText} ${isActive(items?.link) && classes.listItemTextActive}`}
                  sx={{
                    display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                  }}
                >
                  {items?.label}
                </ListItemText>
              )}
            </ListItemButton>
          );
        }
      })}
    </>
  );
};

export default SideNavTabs;
